import React, { useState } from "react";
import prodVuoto from "../prodottoVuoto";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";

function InputCodiceProd(props) {
    const setProductFunction = props.setProductFunction;
    const onSearchResults = props.onSearchResults;
    const [input, setInput] = useState("");
    const showLabels = props.showLabels;
    const showDescs = props.showDescs;
    const orientamento = props.orientamento;
    let inputStyle;

    if (orientamento === "verticale") {
      inputStyle = "pr4 pl4 black-80"
    } else if (orientamento === "orizzontale") {
      inputStyle = "pr4 pl4 black-80 flex"
    } else if (orientamento === "tasto") {
      inputStyle = "black-80 flex measure"
    }

    const handleSubmit= (e) => {
        e.preventDefault()
        const codProduttore = input;
        console.log(codProduttore);
        fetch(apiUrl+"/prodotti/show/codiceproduttore/"+codProduttore)
        .then(resp => resp.json())
        .then(data => {
          if (typeof onSearchResults === "function") {
            onSearchResults(data, {
              tipoRicerca: "codice produttore",
              valoreRicerca: codProduttore,
            });
            return;
          }
          setProductFunction(data[0] || prodVuoto);
        })
      }

    return(
            <div className="mb2">
            <form onSubmit={handleSubmit} class={inputStyle}>
                 {/* <div class="measure"> */}
                 {showLabels && <label for="name" class="b db mr2">Codice produttore</label>}
                    <input value={input}  onChange={e => setInput(e.target.value)}  id="name" className="input-reset ba bordoColScrittaDef-20 pa2 db w-100" type="text" aria-describedby="name-desc" autoComplete="off" />
                    {showDescs && <small id="name-desc" class="f6 black-60 db mb2">Codice modello senza codice colore</small>}
                    {orientamento === "tasto" && <button className={stilePulsanti.classiTastoSblocco} onClick={handleSubmit}><span class="material-icons md-13 gray ma1">search</span></button>}
                {/* </div> */}
            </form>
            </div>
    );

}

export default InputCodiceProd;



